// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"style_checkboxLabel__8y89b","checkboxInput":"style_checkboxInput__vyJx_","checkboxDecor":"style_checkboxDecor__qUE6H","customCheck":"style_customCheck__Nc73b"};